import Vue from 'vue'
import { NavBar } from 'vant'
import { Button } from 'vant'
import { ImagePreview } from 'vant'
import { Image as VanImage } from 'vant'
import { Swipe, SwipeItem } from 'vant'
import { Grid, GridItem } from 'vant'
import { Card } from 'vant'
import { Tag } from 'vant'
import { Icon } from 'vant'
import { Form, Cell, Field, CellGroup } from 'vant'
import { ActionSheet } from 'vant'
import { Dialog } from 'vant'
import { Col, Row } from 'vant'
import { Toast } from 'vant'
import { Loading } from 'vant'
import { Overlay } from 'vant'
import { RadioGroup, Radio } from 'vant'
import { Tab, Tabs } from 'vant'
import { Uploader } from 'vant'
import { Popup } from 'vant'
import { Empty } from 'vant'
import { List } from 'vant'
import { Switch } from 'vant'
import { Checkbox, CheckboxGroup } from 'vant';
import { PullRefresh } from 'vant';
import { Lazyload } from 'vant';

Vue.use(Icon)
Vue.use(Tag)
Vue.use(Card)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(VanImage)
Vue.use(Cell)
Vue.use(Field)
Vue.use(CellGroup)
Vue.use(Form)
Vue.use(ActionSheet)
Vue.use(Dialog)
Vue.use(Col)
Vue.use(Row)
Vue.use(Toast)
Vue.use(Loading)
Vue.use(Overlay)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(ImagePreview)
Vue.use(Button)
Vue.use(Uploader)
Vue.use(Popup)
Vue.use(Empty)
Vue.use(List)
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(NavBar);
Vue.use(PullRefresh);
Vue.use(Lazyload);
